// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SidebarWrapperDiv, SidebarSpacerDiv } from './SidebarStyles';
import {
  toggleSidebar,
  toggleSidebarDevice,
  logout
} from '../../../App/reducer';
import { Device } from '../../../components/Responsive';
import SidebarDeviceBottom from './SidebarDeviceBottom';
import SidebarTop from './SidebarTop';
import SidebarArrow from './SidebarArrow';

type Props = {
  toggleSidebar: () => void,
  sidebarOpened: boolean,
  toggleSidebarDevice: () => void,
  sidebarOpenedDevice: boolean,
  logout: () => void,
  flippers: {
    partner_referrals: boolean
  }
};

class Sidebar extends Component<Props> {
  render() {
    return (
      <SidebarWrapperDiv sidebarOpenedDevice={this.props.sidebarOpenedDevice}>
        <SidebarTop
          sidebarOpened={this.props.sidebarOpened}
          toggleSidebarDevice={this.props.toggleSidebarDevice}
          flippers={this.props.flippers}
        />
        <SidebarSpacerDiv desktopOnly />
        <Device>
          <SidebarDeviceBottom logout={this.props.logout} />
        </Device>
        <SidebarArrow
          toggleSidebar={this.props.toggleSidebar}
          sidebarOpened={this.props.sidebarOpened}
        />
      </SidebarWrapperDiv>
    );
  }
}

const mapStateToProps = state => ({
  sidebarOpened: state.global.sidebarOpened,
  sidebarOpenedDevice: state.global.sidebarOpenedDevice,
  flippers: state.global.flippers
});

const mapDispatchToProps = {
  logout,
  toggleSidebar,
  toggleSidebarDevice
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
